module.exports = __webpack_public_path__ + "static/media/DD.530e33e2.jpeg";